import React from 'react'

export default function InputGroups ({ children }) {
  return (
    <div className={'lc-input-groups'}>
      {children}
    </div>
  )
}
